import { render, staticRenderFns } from "./LimitlessPageHeaderButton.vue?vue&type=template&id=1d35ff58&"
import script from "./LimitlessPageHeaderButton.vue?vue&type=script&lang=js&"
export * from "./LimitlessPageHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports